<template>
  <div>
    <div class="bg-image news"></div>
    <div class="space-sec">
      <div class="_1200 mobile-center">
        <h1 class="main-head">האתר ליחידות מוגברות</h1>
        <p class="under-main-head">
          האתר הידידותי שיעזור לך לעבור בהצלחה את בחינת בגרות בתנ&quot;ך 5 יחידות
          <br />האתר מותאם לתכנית הלימודים של משרד החינוך
        </p>
        <router-link to="/alternatives" class="btn dark w-button">לתכנית הלימודים</router-link>
      </div>
    </div>
    <div class="space-sec quote">
      <blockquote
        class="block-quote"
      >״התנ&quot;ך הוא המנדט שלנו. התנ&quot;ך שנכתב על ידינו, בשפתנו העברית ובארץ הזאת עצמה, הוא־הוא המנדט שלנו״</blockquote>
      <div class="yellow-horz-line"></div>
      <p class="center-txt">דוד בן גוריון</p>
    </div>
    <div v-if="halufot.length" class="_1200 w-clearfix">
      <h2 class="sec-heading">תוכנית לימודים</h2>
      <router-link to="/alternatives" class="showmore">לכל החלופות</router-link>
      <div class="collection-list-wrapper w-dyn-list">
        <div class="collection-list home w-dyn-items">
          <div v-for="halufa in halufot" :key="halufa._id" class="collection-item home w-dyn-item">
            <router-link :to="'alternative/'+halufa._id" class="white-box w-inline-block">
              <div class="white-box-head-box">
                <h4 class="white-box-above-head">{{halufa.author}}</h4>
                <h3 class="white-box-head space">{{halufa.name}}</h3>
              </div>
              <div class="innertxt-box">
                <p class="white-box-txt"></p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="empty-state-5 w-dyn-empty">
          <div>No items found.</div>
        </div>
      </div>
    </div>

    <div class="space-sec">
      <div class="_1200 center">
        <div class="yellow-horz-line"></div>
        <blockquote class="block-quote wide">
          אנחנו כאן לעזרת הקהילה!
          <br />עזור לנו להמשיך לפתח את האתר, ותרום לנו !
        </blockquote>
        <p class="center-txt">קיים אצלנו החזר מס על פי סעיף 46 לפקודת מס הכנסה</p>

        <a
          class="btn yellow w-button"
          href="javascript: (function(){try{var d,i,s,ho,b;d=document;i=d.createElement('iframe');s=i.style;b=d.body;ho=b.style.overflow;b.style.overflow='hidden';s.position='fixed';s.top=s.left=0;s.zIndex='99999999';s.height=s.width='100%';s.border='none';i.src='https://secure.cardcom.solutions/ExternalAisurit4/asrahit.aspx?UID=hAT&st=pm';function l(e){ try{var c=e.data;var x=c.split('-');var u=c.slice(c.indexOf('-')+1);switch(x[0]){case 'Success':d.body.removeChild(i);removeEventListener('message',l);b.style.overflow=ho;break;case 'Redirect':window.location.href=u;removeEventListener('message',l);b.style.overflow=ho;break;}}catch(ex){var track = new Image();track.src = 'https://secure.cardcom.solutions/api/EA4/PixelErrorData?'+'message='+encodeURIComponent('switch case Error Show EA4 popup Function , ex:'+ex)+'&UID='+p+'&uri=0&lineNumber=0&columnNumber=0';document.body.appendChild(track);}}addEventListener('message',l,false);b.appendChild(i);}catch(ex){var track=new Image();track.src='https://secure.cardcom.solutions/api/EA4/PixelErrorData?'+'message='+encodeURIComponent('Global Error Show EA4 popup Function , ex:'+ex)+'&UID='+p+'&uri=0&lineNumber=0&columnNumber=0';document.body.appendChild(track);}})()"
        >לתרומה</a>
      </div>
    </div>

    <div id="Solutions">
      <div class="_1200">
        <h2 class="sec-heading">פתרון בגרויות</h2>
        <router-link :to="'/bagruyot'" class="showmore">לכל הפתרונות</router-link>
        <div class="white-box nohover padd">
          <div v-for="bagrut in bagruyot" :key="bagrut.id" class="questionnaire w-clearfix">
            <img src="../assets/images/book.svg" alt class="image-3" />
            <div class="txt-box">
              <h5 class="heading-2">{{bagrut.name}}</h5>
              <p class="white-box-gray-txt">{{bagrut.subtitle}}</p>
            </div>
            <a
              v-if="bagrut.file"
              :href="bagrut.file.url"
              class="btn yellow left w-button"
              target="_blank"
            >צפייה בקובץ</a>
            <div class="light-gray-line"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="articles.length" class="_1200 w-clearfix">
      <h2 class="sec-heading" style="margin-top:60px">מאמרי העשרה</h2>
      <router-link :to="'/articles'" class="showmore">לכל המאמרים</router-link>
      <div class="collection-list-wrapper w-dyn-list">
        <div class="collection-list-art w-dyn-items">
          <div
            v-for="article in articles"
            :key="article._id"
            class="collection-item-art w-dyn-item"
          >
            <a :href="'/article/'+article._id" class="white-box art-flex w-inline-block w-clearfix">
              <div
                :style="article.image?'background-image:url('+article.image.url+')':''"
                class="art-thumbnail"
              ></div>
              <div class="innerart-box">
                <h4 class="white-box-head">{{article.name}}</h4>
                <p class="txt-box-57">{{article.author}}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  data() {
    return {
      bagruyot: [],
      form: {
        email: "",
        name: "",
        password: "",
        password2: "",
        school: "",
        tos: false
      },
      selectedUI: {
        error: "",
        search: "",
        category: {
          visible: false,
          value: ""
        }
      },
      categories: [],
      aggData: [],
      articles: [],
      halufot: []
    };
  },
  mounted: function() {
    db.collection("/collections/oVwbkKRU39ykpil2lw62/items")
      .orderBy("created", "asc")
      .limit(4)
      .get()
      .then(query => {
        console.log(query);
        query.forEach(doc => {
          var data = doc.data();
          data._id = doc.id;
          this.halufot.push(data);
        });
      });
    db.collection("/collections/OcYF8GHOC5M4cJc9Wm93/items")
      .limit(4)
      .get()
      .then(query => {
        console.log(query);
        query.forEach(doc => {
          var data = doc.data();
          data._id = doc.id;
          this.articles.push(data);
        });
      });

    db.collection("/collections/yjgJg0RayoaMGRqk1o1p/items")
      .limit(3)
      .get()
      .then(query => {
        query.forEach(doc => {
          this.bagruyot.push(doc.data());
        });
      });
  },
  methods: {
    errorlog: function(err) {
      this.selectedUI.error = err;
    },
    fileChange: function(e) {
      if (!this.form.businessName) {
        this.selectedUI.error = "יש קודם למלא שם עסק";
        $(".dropzone").addClass("redborder");
        return;
      } else {
        $(".dropzone").removeClass("redborder");
      }
      var file = e.target.files[0] || e.dataTransfer.files;
      if (!file) {
        return;
      }
      var storageRef = firebase
        .storage()
        .ref(`${this.form.businessName}/rtf/${file.name}`);
      console.log(storageRef);
      console.log(file);
      var uploader = storageRef.put(file);
      console.log(uploader);
      uploader.on(
        "state_changed",
        () => {},
        err => {
          this.businessName.error = err;
        },
        () => {
          uploader.snapshot.ref.getDownloadURL().then(url => {
            this.form.logo = url;
          });
        }
      );
    },
    submit() {
      if (this.password != this.password2) {
        this.selectedUI.error = "סיסמאות לא תואמות";
        return;
      }
      $.each(this.form, (i, e) => {
        if (!e) {
          this.selectedUI.error = "יש למלא את כל השדות";
          return;
        }
      });
      if (!this.form.email.match(/^[\w.-]+@[\w-]+(?:\.[\w-]+)+$/gi)) {
        this.selectedUI.error = "כתובת מייל אינה תקינה";
        return;
      } else {
        this.selectedUI.error = "";
      }
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.form.email, this.form.password)
        .then(profile => {
          uid = profile.user.uid;

          details = {
            email: this.form.email,
            name: this.form.name,
            school: this.form.school
          };
          firebase
            .firestore()
            .doc("collections/nZSsggipwqsg74x8nJBu/items/" + uid)
            .set(details)
            .then(docRef => {
              window.location.href = "/personal-settings";
            });
        })
        .catch(error => {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          this.selectedUI.error = error.message;
          // ...
        });
    },
    search: function(obj, child, term) {
      var include = {};
      $.each(obj, (i, e) => {
        if (e[child].match(new RegExp(term, "gi"))) {
          include[i] = e;
        }
      });
      return include;
    }
  },
  computed: {
    trueFields: function() {
      if (!this.selectedUI.search) {
        return this.categories;
      } else {
        //var term = new RegExp(this.selectedUI.search, 'gi')
        //return this.categories.filter((e)=>{e.name.match(term)})
        return this.search(this.categories, "name", this.selectedUI.search);
      }
    }
  }
};
/*
document.onclick = function(e){
  var clickernutter = $(e.target).closest('.div-block-10').length;
  if(!clickernutter){
    app.selectedUI.category.visible=false
  }
  }*/
</script>

<style>
.under-main-head {
  font-size: 22px;
}
.quote {
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.1)
  );
  background-image: url("../assets/images/beguryon.png");
  background-repeat: no-repeat;
  background-position: 100% 50%;
  background-size: 70%;
}
.showmore::after {
  padding-right: 10px;
  content: url("https://uploads-ssl.webflow.com/5c5ff615f3edced5c3c0aedd/5c614353d885ee8490d1de43_arrow.svg");
}
</style>